// Tworzenie obiektu z selektorami.
import { Dialog } from "../components/Dialog.js";
import { Tools } from "./Tools.js";
import { Preloader } from "../components/Preloader.js";

const $ = function (selector) {
    if (!(this instanceof $)) {
        return new $(selector);
    }

    if (selector) {
        this.selector = selector;
        let newArray = [];
        let selectorArray = selector.split(",");

        for (let i = 0; i < selectorArray.length; i++) {
            newArray = newArray.concat([].slice.call(document.querySelectorAll(selectorArray[i].trim())));
        }

        for (let i = 0; i < newArray.length; i++) {
            this[i] = newArray[i];
        }
    }
};

// Otwarcie okna dialogowego.
$.prototype.dialog = function (settings = {}) {
    if (Object.keys(this).length === 0) {
        throw new Error(
            "Nazwa selektora, jako parametr funkcji $, jest wymagana. Np. iksoris.$('#id-elementu').dialog();."
        );
    }

    for (const key in this) {
        if (Object.hasOwnProperty.call(this, key)) {
            if (key !== "selector") {
                const toggle = this[key];
                new Dialog(toggle, settings);
            }
        }
    }
};

// Ładowanie danych z serwera i umieszczanie zwróconego kodu HTML w dopasowanych elementach.
$.prototype.load = function (url = "", complete = undefined) {
    // Żądanie Ajax
    (async function () {
        // Pokazanie preloadera.
        Preloader.show();

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        });

        return response.text();
    })()
        .then((html) => {
            // Zamknięcie preloadera.
            Preloader.hide();

            for (const key in this) {
                if (Object.hasOwnProperty.call(this, key)) {
                    if (key !== "selector") {
                        const element = this[key];

                        element.innerHTML = html.replace(/<script\b[^>]*>([\s\S]*?)<\/script>/gm, "");
                    }
                }
            }

            // Ładowanie skryptów ze stringa (HTML)
            Tools.loadScriptsDynamically(html);

            // Wywołanie funkcji na zakończenie żądania.
            if (complete) {
                complete();
            }
        })
        .catch((e) => console.log(e));
};

export { $ };
